import script from "./base-search.vue?vue&type=script&setup=true&lang=ts"
export * from "./base-search.vue?vue&type=script&setup=true&lang=ts"

import "./base-search.vue?vue&type=style&index=0&id=3a9fc384&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a9fc384"]])

export default __exports__